import type { ColDef, ColTypeDef } from 'ag-grid-community';

import { technicalColumnDefinition } from '../blotter.model';

export const dragColumnType = {
  ...technicalColumnDefinition,
  pinned: 'left',
  rowDrag: true,
  width: 45,
  minWidth: 45,
  maxWidth: 45,
} satisfies ColDef;

export function useDragColumnType<T>() {
  return dragColumnType as ColTypeDef<T>;
}
